import { Epic, combineEpics, ofType } from 'redux-observable';

import UserEffects from './user/user.effects';
import DashboardEffects from './dashboard/dashboard.effects';
import ListingEffects from './listing/listing.effects';
import InquiriesEffects from './inquiries/inquiries.effects';

export let appEffects: Epic[] = [];

appEffects = appEffects.concat(UserEffects);
appEffects = appEffects.concat(DashboardEffects);
appEffects = appEffects.concat(ListingEffects);
appEffects = appEffects.concat(InquiriesEffects);

export const rootEpic = combineEpics(...appEffects);

// ------- THE SECTION BELOW IS FOR TESTING STORE --------


import * as UserActions from './user/user.actions';
import getStore from '../store';

// setTimeout(() => {
//   const action = {
//     type: UserActions.GET_CURRENT_USER
//   }

//   getStore().dispatch(action);
// }, 1000);
